export var defaultSEO = {
  title: 'Restworld',
  titleTemplate: '%s | Restworld',
  description: 'Restworld',
  twitter: {
    cardType: 'summary_large_image'
  },
  openGraph: {
    type: 'website',
    images: [{
      url: '/og_restworld.png'
    }]
  }
};